import { ReactNode } from 'react';

export enum DemographicInput {
  Age = 'age',
  Gender = 'gender',
  Smoker = 'smoker',
}

export type ProductSpec = {
  headlineColor: string;
  code: string;
  order: number;
  sumAssured: boolean;
  premiumScheduleLabel: ReactNode;
  sumAssuredInput?: boolean;
  demographicInputs?: DemographicInput[];
  defaultFormValues?: Partial<QuotationForm>;
};

export type QuotationForm = {
  gender: 'male' | 'female';
  smoker: 'smoker' | 'non-smoker';
  age: number;
  sumAssured: number;
};

export type SocialProofSpec = {
  min_age: number;
  max_age: number;
  comparison_result: number;
};

export type ProductSocialProofSpec = {
  product_code: string;
} & SocialProofSpec;
